import {useEffect,memo,useState,useRef} from 'react';
import {useAS2CommStatusContextProvider} from "../As2CommStatusContextProvider";
import PropTypes from 'prop-types';
import axios from "axios";
import Tooltip from '@mui/material/Tooltip';
import { DataGrid,Toolbar,useGridSelector, 

    ColumnsPanelTrigger ,FilterPanelTrigger,gridDensitySelector,
    useGridApiContext,gridSortedRowIdsSelector, ToolbarButton, 
    GridNoRowsOverlay} from '@mui/x-data-grid';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import FilterListIcon from '@mui/icons-material/FilterList';
import SettingsIcon from '@mui/icons-material/Settings';
import {  styled,darken, lighten} from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CheckIcon from '@mui/icons-material/Check';
import TableChartIcon from '@mui/icons-material/TableChart';


import {getAs2SummaryTableColumns} from "./Adapter";
import {customFormatDateTime} from "../utils/dateUtils";
import {useOktaAuth} from '@okta/okta-react';

const As2CommStatusSummaryTable=memo((props)=> {
    const {as2QueryParams}=useAS2CommStatusContextProvider();
    const {fromDate, toDate, supplierNumber, direction, as2SenderId,as2ReceiverId,unitCode,forceUpdate}=as2QueryParams;
    const [as2SummaryData,setAs2SummaryData]=useState([]);
    const [noAs2SummaryData,setNoAs2SummaryData]=useState("Specify a criteria first");
    const [loading, setLoading] = useState(false);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 100,
    });
    const [rowCount, setRowCount] = useState(0);

    const {oktaAuth} = useOktaAuth();

    const getBackgroundColor = (color, mode) =>
        mode === 'dark' ? darken(color, 0.7) : lighten(color, 0.7);

    const getHoverBackgroundColor = (color, mode) =>
        mode === 'dark' ? darken(color, 0.6) : lighten(color, 0.6);

    const getSelectedBackgroundColor = (color, mode) =>
        mode === 'dark' ? darken(color, 0.5) : lighten(color, 0.5);

    const getSelectedHoverBackgroundColor = (color, mode) =>
        mode === 'dark' ? darken(color, 0.4) : lighten(color, 0.4);

    const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
        '& .table-theme--0': {
            backgroundColor: getBackgroundColor(
                theme.palette.error.main,
                theme.palette.mode,
            ),
            '&:hover': {
                backgroundColor: getHoverBackgroundColor(
                    theme.palette.error.main,
                    theme.palette.mode,
                ),
            },
            '&.Mui-selected': {
                backgroundColor: getSelectedBackgroundColor(
                    theme.palette.error.main,
                    theme.palette.mode,
                ),
                '&:hover': {
                    backgroundColor: getSelectedHoverBackgroundColor(
                        theme.palette.error.main,
                        theme.palette.mode,
                    ),
                },
            },
        },
        '& .table-theme--2': {
            backgroundColor: getBackgroundColor(
                theme.palette.success.main,
                theme.palette.mode,
            ),
            '&:hover': {
                backgroundColor: getHoverBackgroundColor(
                    theme.palette.success.main,
                    theme.palette.mode,
                ),
            },
            '&.Mui-selected': {
                backgroundColor: getSelectedBackgroundColor(
                    theme.palette.success.main,
                    theme.palette.mode,
                ),
                '&:hover': {
                    backgroundColor: getSelectedHoverBackgroundColor(
                        theme.palette.success.main,
                        theme.palette.mode,
                    ),
                },
            },
        },
        '& .table-theme--1': {
            backgroundColor: getBackgroundColor(
                theme.palette.warning.main,
                theme.palette.mode,
            ),
            '&:hover': {
                backgroundColor: getHoverBackgroundColor(
                    theme.palette.warning.main,
                    theme.palette.mode,
                ),
            },
            '&.Mui-selected': {
                backgroundColor: getSelectedBackgroundColor(
                    theme.palette.warning.main,
                    theme.palette.mode,
                ),
                '&:hover': {
                    backgroundColor: getSelectedHoverBackgroundColor(
                        theme.palette.warning.main,
                        theme.palette.mode,
                    ),
                },
            },
        },
    }));
const DENSITY_OPTIONS = [
  { label: 'Compact density', value: 'compact' },
  { label: 'Standard density', value: 'standard' },
  { label: 'Comfortable density', value: 'comfortable' },
];
    const getUnfilteredRows = ({ apiRef }) => gridSortedRowIdsSelector(apiRef);

    const buttonBaseProps = {
        color: 'primary',
        size: 'small',
        startIcon: <TableChartIcon />,
    };

    const CustomToolbar=()=> {
        const apiRef = useGridApiContext();
        const density = useGridSelector(apiRef, gridDensitySelector);
        const [densityMenuOpen, setDensityMenuOpen] = useState(false);
        const densityMenuTriggerRef = useRef(null);

        const handleExport = (options) => apiRef.current.exportDataAsCsv(options);
        return(
            <Toolbar>
                <ColumnsPanelTrigger  >
                    <ViewColumnIcon fontSize="small" />
                    Columns
                </ColumnsPanelTrigger>
                <FilterPanelTrigger >
                    <FilterListIcon fontSize="small"/>
                    Filters
                </FilterPanelTrigger>

                <Tooltip title="Settings">
                  <Button
                    ref={densityMenuTriggerRef}
                     sx={{
                        borderColor: "green",
                      }}
                    id="density-menu-trigger"
                    aria-controls="density-menu"
                    aria-haspopup="true"
                    aria-expanded={densityMenuOpen ? 'true' : undefined}
                    onClick={() => setDensityMenuOpen(true)}
                  >
                    <fuel-icon name="menu" />Density
                  </Button>
                </Tooltip>

                <Menu
                  id="density-menu"
                  anchorEl={densityMenuTriggerRef.current}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                  open={densityMenuOpen}
                  onClose={() => setDensityMenuOpen(false)}
                  slotProps={{
                    list: {
                      'aria-labelledby': 'density-menu-trigger',
                    },
                  }}
                >
                  {DENSITY_OPTIONS.map((option) => (
                    <MenuItem
                      key={option.value}
                      onClick={() => {
                        apiRef.current.setDensity(option.value);
                        setDensityMenuOpen(false);
                      }}
                    >
                      <ListItemIcon>
                        {density === option.value && <CheckIcon fontSize="small" />}
                      </ListItemIcon>
                      <ListItemText>{option.label}</ListItemText>
                    </MenuItem>
                  ))}
                </Menu>
                
                <Button
                    {...buttonBaseProps}

                    onClick={() => handleExport({ getRowsToExport: getUnfilteredRows })}
                >
                    Download
                </Button>

            </Toolbar>
        )
    }
    const StyledGridOverlay = styled('div')(({ theme }) => ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        backgroundColor: 'rgba(18, 18, 18, 0.9)',
        ...theme.applyStyles('light', {
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
        }),
        }));
    const CustomLoadingOverlay=()=> {
        return ( 
        <StyledGridOverlay>
            <div style={{ fontWeight: "bold" }}>{noAs2SummaryData}</div>
        </StyledGridOverlay>
    );
}


    useEffect(() => {
        const fetchAs2SummaryData = async (queryString) => {
            return await axios.get(process.env.REACT_APP_EDI_AS2_COMMUNICATION_STATUS_BASE_URL + queryString,
                {
                    headers: {
                        'Authorization': 'Bearer ' + oktaAuth.getAccessToken()
                    }
                });
        };

        if (supplierNumber){

            setAs2SummaryData([]);
            setLoading(true);
            const fromString = customFormatDateTime(fromDate);
            const toString = customFormatDateTime(toDate);
            let queryString = `/api/as2/communication-status?from=${fromString}&to=${toString}&supplierNum=${supplierNumber}`;
            const params=[];
            if (direction!=="A"){
                params.push(`&direction=${direction}`);
            }
            if ( as2SenderId !== ""){
                params.push(`&senderAs2Id=${as2SenderId}`)
            }
            if ( as2ReceiverId !== ""){
                params.push(`&receiverAs2Id=${as2ReceiverId}`)
            }
            if ( unitCode !== "" && unitCode.length>=4){
                params.push(`&unit=${unitCode}`)
            }

            //pagination parameters
            params.push(`&page=${paginationModel.page}`);
            params.push(`&size=${paginationModel.pageSize}`);

            if (params.length>0){
                queryString=queryString+params.join("");
            }

            fetchAs2SummaryData(queryString).then((response) => {
                let responseData = response?.data;
                
                
                if (responseData && responseData.content && Array.isArray(responseData.content)) {
                    let data = responseData.content;
                    setRowCount(responseData.totalElements || 0);
                    
                    if (data.length > 0) {
                        data.sort((p1, p2) => {
                            return p1.asStatusAsNumber - p2.asStatusAsNumber;
                        });
                        setAs2SummaryData(data);
                    } else {
                        setAs2SummaryData([]);
                        setNoAs2SummaryData("No data found");
                    }
                } else {
                    console.error("Unexpected response format:", responseData);
                    setAs2SummaryData([]);
                    setNoAs2SummaryData("No data found");
                    setRowCount(0);
                }

            }).catch((error) => {
                console.log(error,error.response);
                if (error.response?.data?.message){
                    setNoAs2SummaryData(error.response.data.message);
                } else {
                    setNoAs2SummaryData("Failed to load data");
                }
                setRowCount(0);
            }).finally(() => {
                setLoading(false); 
            });
        }else{
            setAs2SummaryData([]);
            setNoAs2SummaryData("Specify a criteria first");
            setLoading(false);
            setRowCount(0);
        }

    }, [as2QueryParams, forceUpdate, paginationModel]);

    return (
        <div style={{ height: "50vh",  flexDirection: 'column' }}>
            <StripedDataGrid
                loading={loading}
                rows={as2SummaryData}
                columns={getAs2SummaryTableColumns()}
                slots={{
                    noRowsOverlay: CustomLoadingOverlay,
                    toolbar: CustomToolbar,
                }}
                slotProps={{
                    loadingOverlay: {
                    variant: 'circular-progress',
                    noRowsVariant: 'circular-progress',
                    },
                }}
                
                paginationMode="server"
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                rowCount={rowCount}
                pageSizeOptions={[20, 50, 100]}
                showToolbar
                filterOptions={(x) => x}
                sx={{
                    borderColor: "rgb(204, 204, 204)"
                }} 
                getRowClassName={(params) => `table-theme--${params.row.asStatusAsNumber}`}
                onRowClick={(ids) => {
                    const  id = ids.id;
                    const selectedRow = as2SummaryData.filter(item=> item.id===id);
                    props.handlerDetails(selectedRow[0]);
                }}
                getCellClassName={(params) => {
                    return 'cell';
                }} 

                />
        </div>
    );


});
As2CommStatusSummaryTable.propTypes={
    handlerDetails: PropTypes.func.isRequired
}
export default As2CommStatusSummaryTable;